import React, { useEffect } from 'react'
import ClickBlockOverlay from './ClickBlockOverlay'
import Button from './Button'
import './HintWrapper.scss'
import { HintPosition } from '../Enums'
import classNames from 'classnames'


interface Props {
  children: React.ReactNode
  isShown: boolean
  hintPosition: HintPosition
  message: string
  handleDismiss: () => void
  appearDelayMs: number
  responsive?: boolean
}

// Use this component to wrap controls that have a dismissible hint. Wrapping is required for positioning reasons.

export default function HintWrapper({ children, isShown, message, handleDismiss, hintPosition, appearDelayMs, responsive }: Props) {
  // Set delay to allow for other animations (that affect target element position) to finish.
  const [mountDelayFinished, setMountDelayFinished] = React.useState(false)
  const readyToDisplay = isShown && mountDelayFinished

  useEffect(() => {
    // Component mounted
    if (isShown) {
      setTimeout(() => setMountDelayFinished(true), appearDelayMs)
    }
  }, [isShown, appearDelayMs])

  return (
    <>
      {readyToDisplay && (
        <ClickBlockOverlay background="#fff9"/>
      )}
      <div className={classNames('HintWrapper', { isShown: readyToDisplay })}>
        <span className={readyToDisplay ? 'preventClicks' : ''}>
          {children}
        </span>
        {readyToDisplay && (
          <div className={classNames('hintBox', hintPosition, { responsive })}>
            <div className="messageContainer">
              {message}
            </div>
            <Button buttonStyle="white" onClick={handleDismiss}>
              Got it!
            </Button>
          </div>
        )}
      </div>
    </>
  )
}